import { gql } from '@apollo/client';

export const userListingForDates = gql`
    query ($listId:Int!, $preview: Boolean) {
      UserListing (listId:$listId, preview: $preview) {
        id
        userId
        bookingType
        isPublished
        listApprovalStatus
        houseRules {
          houseRulesId
        }
        listingData {
          bookingNoticeTime,
          checkInStart,
          checkInEnd,
          maxDaysNotice,
          minNight,
          maxNight,
          basePrice,
          cleaningPrice,
          tax,
          currency,
          weeklyDiscount,
          monthlyDiscount,
          cancellationPolicy
        }
        blockedDates {
          blockedDates
          reservationId
          calendarStatus
          isSpecialPrice
        }
        calendars {
          id
          name
          url
          listId
          status
        }
        listBlockedPrice {
          listId
          calendarStatus
          isSpecialPrice
          blockedDates
          calendarId
          reservationId
        }
      }
    }
    `;

export const getBlockedDatesCalendar = gql`
    query ($listId: Int!, $filterDate: String) {
        getBlockedDatesCalendar(listId: $listId, filterDate: $filterDate) {
            listId
            blockedDates
        }
    }
    `;

export const getSpecialPricing = gql`
    query (
        $listId:Int!,  
        $startDate: String!, 
        $endDate: String!
    ) {
        getSpecialPricing (
            listId:$listId, 
            startDate:$startDate, 
            endDate: $endDate
        ) {
            id
            listId
            blockedDates
            calendarStatus
            isSpecialPrice
            dayStatus
        }
    }
    `;
    
export const listBlockedDates = gql`query ListingBlockedDates ($listId:Int!, $preview: Boolean) {
    UserListing (listId:$listId, preview: $preview) {
    id
    viewListBlockedDates {
        calendarId
        calendarStatus
        dayStatus
        blockedDates
        isSpecialPrice
      }
      fullBlockDates {
        calendarId
        calendarStatus
        dayStatus
        blockedDates
        isSpecialPrice
      }  
    }
  }
`;

export const DateAvailability = gql`
    query ($listId:Int!,  $startDate: String!, $endDate: String!) {
    DateAvailability (listId:$listId, startDate:$startDate, endDate: $endDate) {
      status
    }
    }
    `;